module.exports = __webpack_public_path__ + "img/vip_detail_bg.f58265f1.png";